<div class="ng-bento">
	<bento-alert [items]="alerts">
	</bento-alert>

	<div [bentoBusyLoader]="isLoading"
			*ngIf="isLoading"
			class="loader">
	</div>

	<div class="theme-container"
			*ngIf="!isLoading">
		<h1 class="no-margin-t"
				translate="onvio.setup.theme.titles.appearanceSetup"></h1>
		<div class="row cc-setup">
			<h2 class="col-xs-12"
					translate="onvio.setup.theme.titles.clientCenterSetup"></h2>
			<div class="col-md-5">
				<h3 translate="Onvio.Setup.Theme.FirmName"></h3>
				<ng-template [ngIf]="isAuth0Disabled" [ngIfElse]="auth0Text">
					<p translate="Onvio.Setup.Theme.FirmName.Description"></p>
				</ng-template>
				<ng-template #auth0Text>
					<p translate="Onvio.Setup.Theme.FirmName.DescriptionComplete"></p>
				</ng-template>
				<div class="row">
					<div [(ngModel)]="headerIsText"
							ngbRadioGroup
							class="btn-group btn-group-toggle col-xs-12"
							name="headerToggle">
							<label ngbButtonLabel
							class="btn btn-outline-primary btn-toggle">
							<span translate="Onvio.Setup.Theme.FirmName.Text"></span>
							<input ngbButton
								type="radio"
								[value]="'HeaderText'">
							</label>
							<label ngbButtonLabel
								*ngIf="!hasBRHideStaffFirmLogoSetting"
								class="btn btn-outline-primary btn-toggle">
								<span translate="Onvio.Setup.Theme.FirmName.FirmLogoHeader"></span>
									<input ngbButton
									type="radio"
									[value]="'HeaderLogo'">
							</label>
							<label ngbButtonLabel
								class="btn btn-outline-primary btn-toggle">
								<span translate="Onvio.Setup.Theme.FirmName.Image"></span>
								<input ngbButton
									type="radio"
									[value]="'HeaderImage'">
							</label>
					</div>
				</div>

				<div class="row site-title">
					<div class="col-xs-12"
								*ngIf="headerIsText === 'HeaderText'">
							<label translate="bmt.ColumnHeader.FirmName" for="firmName"
										class="site-settings-label"></label>
							<input class="site-settings-input" id="firmName"
										[(ngModel)]="theme.headerLine1"
										required />
					</div>
					<div class="col-xs-12 row" *ngIf="headerIsText === 'HeaderLogo' && bannerExist">
						<span class="col-xs-12" translate="Onvio.Setup.Theme.FirmName.FirmLogoDescription"></span>
							<div class="col-xs-12">
									<div class="div-firm-logo-exist">
										<img [src]="firmBanner" class="firm-img-preview">
									</div>
							</div>
					</div>
					<div class="col-xs-12" *ngIf="headerIsText === 'HeaderLogo' && !bannerExist">
						<div class="col-md-14">
							<div class="card preview-container">
								<h4 class="card-header" translate="Onvio.Setup.Theme.FirmName.FirmLogo"></h4>
									<div class="card-body">
										<div *ngIf="!bannerExist" class="div-firm-logo-not-exist">
										<span *ngIf="hasSetupPermission === true" translate="Onvio.Setup.Theme.FirmName.FirmLogoNotSetFREnable">
										</span>
										<span *ngIf="hasSetupPermission === true">{{' '}}</span>
										<a [href]="getFirmClientLink()"
											target="_self"
											*ngIf="hasSetupPermission === true"
											translate="Onvio.Setup.Theme.FirmName.FirmLogoFirmSettings">
										</a>
										<p *ngIf="hasSetupPermission === false" translate="Onvio.Setup.Theme.FirmName.FirmLogoNotSet"></p>
										</div>
									</div>
							</div>
							</div>
					</div>
					<div class="col-xs-12 row"
								*ngIf="headerIsText === 'HeaderImage'">
						<span class="col-xs-12"
									translate="Onvio.Setup.Theme.Image.Description">
						</span>
						<div class="image-selector col-xs-12">
							<bento-file-selector *ngIf="!imageSuccess"
																	[(ngModel)]="selectedFiles"
																	[showSelectedFiles]="false"
																	[multiple]="false"
																	[showFileSize]="false"
																	[appendOnSelection]="false"
																	[accept]="'image/*'"
																	(fileSelect)="fileSelected($event)"></bento-file-selector>
							<div *ngIf="imageErrorStrings"
									class="text-error">
								<span *ngFor="let error of imageErrorStrings">
									{{error}}
								</span>
							</div>
							<div class="img-preview-container"
									*ngIf="imageSuccess">
								<img [src]="theme.headerImage"
										class="img-preview">
								<i class="bento-icon-close-circle"
									(click)="removeImage()"
									(keyup.enter)="removeImage()"
									tabindex="0"></i>
							</div>
						</div>
					</div>
				</div>

				<div class="row accent-color">
					<h3 class="col-xs-12"
							translate="Onvio.Setup.Theme.AccentColor"></h3>
					<p class="col-xs-12"
						translate="Onvio.Setup.Theme.AccentColor.Description">
					</p>
					<p class="col-xs-12"
						translate="Onvio.Setup.Theme.AccentColor.Select"></p>
					<div class="col-xs-12">
						<div class="accent-color-picker" role="radiogroup">
							<div class="accent-color-option"
									role="radio"
									tabindex="0"
									*ngFor="let color of objectKeys(accentColors)"
									(keyup.enter)="selectColor(accentColors[color].color.getHexString())"
									[attr.aria-checked]="accentColors[color].selected">
								<div class="swatch"
										[style.background-color]="accentColors[color].color.getRGBString() | async"
										[class.selected]="accentColors[color].selected"
										(click)="selectColor(accentColors[color].color.getHexString())">
									<i class="bento-icon-checkmark"
										*ngIf="accentColors[color].selected"></i>
								</div>
								<span translate="Onvio.Setup.Theme.AccentColor.{{accentColors[color].colorName}}"></span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-7">
				<div class="card preview-container">
					<h4 class="card-header"
							translate="Onvio.Setup.Theme.Titles.Preview"></h4>
					<div class="card-body">
						<app-client-center-preview [accent]="accentColors[theme.colors.buttonFillColor].color"
																			[headerText]="theme.headerLine1"
																			[headerIsText]="headerIsText"
																			[imageSrc]="headerIsText === 'HeaderLogo' ? firmBanner : theme.headerImage"
																			[imageSuccess]="imageSuccess">
						</app-client-center-preview>
					</div>
				</div>
			</div>
		</div>

		<h2 class="h1" translate="onvio.appearance.html.signIn"></h2>
		<div class="row">
			<span class="sr-only" id="copy-html-and-css-combined-text">{{ 'onvio.setup.appearance.signinForm.code.copy' | translate }} {{ 'onvio.setup.appearance.signinForm.code.title' | translate }}</span>
			<div class="col-xs-12" *ngIf="isAuth0Disabled" >
				<h3 class="h2" class="col-xs-12"
					translate="Onvio.Appearance.Html.SignIn.BackGround"></h3>
				<div class="col-xs-12 background-container">
					<div class="signin-background-thumb bm-{{theme.loginBackground}}"></div>
					<button class="btn btn-outline-primary"
									(click)="launchSelector(background)"
									translate="Onvio.Appearance.Html.SignIn.ChooseBackGround">
					</button>
				</div>
			</div>

			<h3 class="h2 col-xs-12"
					translate="onvio.setup.appearance.signoutUrlHeader"></h3>
			<div class="col-xs-12">
				<label for="signout-input"><span translate="onvio.setup.appearance.signoutUrlLabel" ></span></label>
				<br/>
				<input class="site-settings-input"
							id="signout-input"
							type="text"
							[placeholder]="rootUrl + '/clientcenter'"
							[(ngModel)]="theme.logoutUrl">
				<a class="btn btn-outline-primary new-tab-button"
					[href]="getSignOutUrl()"
					target="_blank">
					<span translate="Onvio.Appearance.Html.SignOut.NewTab"></span>
					<i class="bento-icon-newtab"></i>
				</a>
			</div>

			<h3 class="h2 col-xs-12"
					translate="onvio.setup.appearance.signinForm.client.title"></h3>
			<div class="col-lg-6">
				<p translate="onvio.setup.appearance.signinForm.client.instructions"></p>
				<div class="code-preview">
						<div class="bar">
								<h3 translate="onvio.setup.appearance.signinForm.code.title"></h3>
								<button (click)="copyToClipboard(clientCenterSigninHTML)" aria-labelledby="copy-html-and-css-combined-text" class="btn btn-outline-primary" translate="onvio.setup.appearance.signinForm.code.copy"></button>
						</div>
						<pre tabindex="0">
								{{clientCenterSigninHTML}}
						</pre>
				</div>
			</div>
			<div class="col-lg-6">
				<h4 class="h3" translate="onvio.setup.appearance.signinForm.preview"></h4>
				<div class="sign-in-preview" [innerHTML]="sanitizer.bypassSecurityTrustHtml(clientCenterSigninHTML)"></div>
			</div>

			<h3 class="h2 col-xs-12"
					translate="onvio.setup.appearance.signinForm.staff.title"></h3>
			<div class="col-lg-6">
				<p translate="onvio.setup.appearance.signinForm.staff.instructions"></p>
				<div class="code-preview">
						<div class="bar">
								<h3 translate="onvio.setup.appearance.signinForm.code.title"></h3>
								<button (click)="copyToClipboard(onvioSigninHTML)" aria-labelledby="copy-html-and-css-combined-text" class="btn btn-outline-primary" translate="onvio.setup.appearance.signinForm.code.copy"></button>
						</div>
						<pre>
								{{onvioSigninHTML}}
						</pre>
				</div>
			</div>
			<div class="col-lg-6">
				<h4 class="h3" translate="onvio.setup.appearance.signinForm.preview"></h4>
				<div class="sign-in-preview" [innerHTML]="sanitizer.bypassSecurityTrustHtml(onvioSigninHTML)"></div>
			</div>
		</div>
	</div>

	<div class="theme-footer"
			*ngIf="!isLoading">
		<button class="btn btn-primary"
						(click)="save()"
						translate="onvio.setup.notifications.save"
						[disabled]="isSaving"
						[bentoBusyLoader]="isSaving">
		</button>
		<button class="btn btn-outline-primary"
						(click)="cancel()"
						translate="Onvio.Setup.Theme.Buttons.DiscardChanges"
						[disabled]="isSaving">
		</button>
	</div>
</div>

<ng-template #background>
	<button type="button"
					class="close"
					aria-label="Close"
					(click)="closeSelector('close')">
		<i class="bento-icon-close-x"
			aria-hidden="true"></i>
	</button>
	<div class="modal-header"
			translate="Onvio.Appearance.Html.SignIn.ChooseBackGround">
	</div>
	<div class="modal-body no-margin">
		<div class="selector-container">
			<div class="signin-background-thumb bm-{{background}}"
					[class.selected]="backgrounds[background]"
					*ngFor="let background of objectKeys(backgrounds); let i = index;"
					(click)="selectBackground(background)"
					(keyup.enter)="selectBackground(background)"
					tabindex="0"
					role="img"
					[attr.aria-label]="background"
					>
				<div class="active-icon"
						*ngIf="backgrounds[background]">
					<i class="bento-icon-checkmark"></i>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button"
						class="btn btn-primary"
						(click)="chooseBackground()"
						translate="Bluemoon.Core.Setup.EditMultiple.Common.Choose.Title"></button>
		<button type="button"
						class="btn btn-outline-primary"
						(click)="closeSelector('close')"
						translate="Bluemoon.Components.Common.Actions.Cancel"></button>
	</div>
</ng-template>
